import {IntermediatePart} from "../../parts/intermediatePart";
import {BathTubType} from "../../constants";

export default class BathTubSpa extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bathtub_spa';
    this.translateId = "visualizer.bathroom.bathtub.bathtub_spa";
    this.partName = 'Spa';
    this.visible = [BathTubType.Custom60in];
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BathTubSpa());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.BathTub.Custom60in.Spa;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.BathTub.Custom60in.Spa;
    }
  }
}
